/* DARKGROUND DESIGN SYSTEM · behaviour
   - [data-dg-action="buy"]: clicks the theme's native add to cart (keeps cart drawer, upsell and pixel)
   - [data-dg-bgvideo] video: plays only while visible, respects reduced motion
   - [data-dg-sticky-bar]: shows after [data-dg-hero-buy], hides while [data-dg-buy-section] is visible
   - [data-dg-player]: A/B player fed by AW Player pairs (same title, artist BEFORE / AFTER)
*/
(function () {
  'use strict';

  function nativeButton() {
    var list = document.querySelectorAll('.add-to-cart-button, form[action*="/cart/add"] [name="add"]');
    for (var i = 0; i < list.length; i++) { if (!list[i].disabled) return list[i]; }
    return null;
  }

  function bindBuy(root) {
    root.querySelectorAll('[data-dg-action="buy"]').forEach(function (btn) {
      if (btn.dataset.dgBound) return;
      btn.dataset.dgBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var n = nativeButton();
        if (n) { n.click(); return; }
        var f = document.querySelector('.dg-buy__form');
        if (f) f.submit();
      });
    });
  }

  function bindVideos(root) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-dg-bgvideo] video').forEach(function (vid) {
      if (vid.dataset.dgBound) return;
      vid.dataset.dgBound = '1';
      vid.muted = true;
      if (reduced) { vid.removeAttribute('autoplay'); vid.pause(); return; }
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { vid.play().catch(function () {}); } else { vid.pause(); } });
      }, { threshold: 0.05 }).observe(vid);
    });
  }

  function bindSticky() {
    var bar = document.querySelector('[data-dg-sticky-bar]');
    if (!bar) { document.documentElement.classList.remove('dg-sticky-on'); return; }
    if (bar.dataset.dgBound) return;
    bar.dataset.dgBound = '1';
    var heroBuy = document.querySelector('[data-dg-hero-buy]');
    var buySec = document.querySelector('[data-dg-buy-section]');
    var state = { heroPassed: !heroBuy, buyVisible: false };
    function update() {
      var show = state.heroPassed && !state.buyVisible;
      bar.classList.toggle('is-visible', show);
      bar.inert = !show;
      document.documentElement.classList.toggle('dg-sticky-on', show);
    }
    if (!('IntersectionObserver' in window)) { state.heroPassed = true; update(); return; }
    if (heroBuy) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { state.heroPassed = !en.isIntersecting && en.boundingClientRect.top < 0; });
        update();
      }).observe(heroBuy);
    }
    if (buySec) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { state.buyVisible = en.isIntersecting; });
        update();
      }, { threshold: 0.15 }).observe(buySec);
    }
    update();
  }

  function bars(str, n) {
    var vals = (str || '').split(',').map(function (x) { return Math.abs(parseFloat(x) || 0); });
    var out = [];
    if (!vals.length) { for (var k = 0; k < n; k++) out.push(0.2); return out; }
    var size = vals.length / n;
    for (var i = 0; i < n; i++) {
      var m = 0, s = Math.floor(i * size), e = Math.max(s + 1, Math.floor((i + 1) * size));
      for (var j = s; j < e && j < vals.length; j++) if (vals[j] > m) m = vals[j];
      out.push(m);
    }
    return out;
  }

  function buildPlayer(root, tracks) {
    var pairs = [], map = {};
    tracks.forEach(function (t) {
      var key = (t.title || '').trim();
      var side = (t.artist || '').trim().toUpperCase();
      if (!key || (side !== 'BEFORE' && side !== 'AFTER')) return;
      if (!map[key]) { map[key] = { name: key }; pairs.push(map[key]); }
      map[key][side === 'BEFORE' ? 'before' : 'after'] = t;
    });
    pairs = pairs.filter(function (p) { return p.before && p.after; });
    if (!pairs.length) return;
    root.hidden = false;

    var d = root.dataset;
    var N = window.innerWidth < 750 ? 64 : 120;
    var tabsEl = root.querySelector('[data-dg-tabs]');
    var waveEl = root.querySelector('[data-dg-wave]');
    var playBtn = root.querySelector('[data-dg-play]');
    var iconPlay = root.querySelector('[data-dg-icon-play]');
    var iconPause = root.querySelector('[data-dg-icon-pause]');
    var modeBtns = root.querySelectorAll('[data-dg-mode]');
    var hint = root.querySelector('[data-dg-hint]');
    var state = { i: 0, mode: 'before', playing: false, switched: false };
    var a = new Audio(), b = new Audio();
    [a, b].forEach(function (x) { x.loop = true; x.preload = 'auto'; });
    var spans = [];
    waveEl.innerHTML = ''; tabsEl.innerHTML = '';
    for (var k = 0; k < N; k++) { var s = document.createElement('span'); waveEl.appendChild(s); spans.push(s); }

    function active() { return state.mode === 'after' ? b : a; }
    function drawWave() {
      var p = pairs[state.i];
      var bb = bars(p.before.waveform, N), ba = bars(p.after.waveform, N);
      var max = Math.max.apply(null, bb.concat(ba)) || 1;
      var src = state.mode === 'after' ? ba : bb;
      spans.forEach(function (el, idx) { el.style.height = Math.max(4, Math.round(src[idx] / max * 100)) + '%'; });
    }
    function drawProgress() {
      var x = active();
      var pct = x.duration ? x.currentTime / x.duration : 0;
      var upto = Math.floor(pct * N);
      spans.forEach(function (el, idx) { el.classList.toggle('is-played', state.playing && idx <= upto); });
      if (state.playing) requestAnimationFrame(drawProgress);
    }
    function setMode(m) {
      state.mode = m;
      modeBtns.forEach(function (btn) { btn.setAttribute('aria-pressed', btn.getAttribute('data-dg-mode') === m ? 'true' : 'false'); });
      root.classList.toggle('is-on', m === 'after');
      a.muted = m === 'after';
      b.muted = m !== 'after';
      if (state.playing) {
        var from = m === 'after' ? a : b, to = active();
        if (Math.abs(to.currentTime - from.currentTime) > 0.04) to.currentTime = from.currentTime;
      }
      if (m === 'after') state.switched = true;
      hint.textContent = m === 'after' ? (d.hintOn || '') : (d.hintOff || '');
      drawWave();
    }
    function stop() {
      a.pause(); b.pause();
      state.playing = false;
      iconPlay.style.display = ''; iconPause.style.display = 'none';
      playBtn.setAttribute('aria-label', 'Play example');
      drawProgress();
    }
    function play() {
      a.currentTime = 0; b.currentTime = 0;
      a.muted = state.mode === 'after'; b.muted = state.mode !== 'after';
      Promise.all([a.play(), b.play()]).then(function () {
        state.playing = true;
        iconPlay.style.display = 'none'; iconPause.style.display = '';
        playBtn.setAttribute('aria-label', 'Pause example');
        if (!state.switched) hint.textContent = d.hintPlaying || '';
        requestAnimationFrame(drawProgress);
      }).catch(function () {});
    }
    function load(i) {
      var was = state.playing;
      stop();
      state.i = i;
      a.src = pairs[i].before.url;
      b.src = pairs[i].after.url;
      tabsEl.querySelectorAll('button').forEach(function (t, idx) { t.setAttribute('aria-selected', idx === i ? 'true' : 'false'); });
      drawWave();
      if (was) play();
    }
    b.addEventListener('timeupdate', function () {
      if (state.playing && Math.abs(a.currentTime - b.currentTime) > 0.06) {
        (state.mode === 'after' ? a : b).currentTime = active().currentTime;
      }
    });
    pairs.forEach(function (p, idx) {
      var t = document.createElement('button');
      t.type = 'button'; t.className = 'dg-ab__tab'; t.setAttribute('role', 'tab');
      t.textContent = p.name;
      t.addEventListener('click', function () { load(idx); });
      tabsEl.appendChild(t);
    });
    playBtn.addEventListener('click', function () { state.playing ? stop() : play(); });
    modeBtns.forEach(function (btn) { btn.addEventListener('click', function () { setMode(btn.getAttribute('data-dg-mode')); }); });
    load(0);
    setMode('before');
    hint.textContent = d.hintStart || '';
  }

  function initPlayer(root) {
    if (!root || root.dataset.dgBound) return;
    root.dataset.dgBound = '1';
    fetch('/apps/awplayer/tracks?product_id=' + root.getAttribute('data-product-id'))
      .then(function (r) { return r.json(); })
      .then(function (data) { buildPlayer(root, (data && data.tracks) || []); })
      .catch(function () {});
  }

  function setup(root) {
    root = root || document;
    bindBuy(root);
    bindVideos(root);
    root.querySelectorAll('[data-dg-player]').forEach(initPlayer);
    bindSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(document); });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
